module.exports = {
    亚马逊: '亚马逊礼品卡',
    沃尔玛: '沃尔玛礼品卡',
    星巴克: '星巴克礼品卡',
    苹果卡: '苹果礼品卡',
    selected: '已选择',
    reviewGuide: {
        title: '如何在购买平台留下评价',
        subtitle: '选择平台查看操作步骤。'
    },
    showGiftCard: {
        title: '您的延长保修已激活。<br>我们已为您的产品增加 <strong>9 个月</strong>的保修服务。<br>感谢您的购买！',
        text: '🎁 领取您的 20 美元礼品卡并分享您的体验<br><small>（不到 1 分钟）</small>',
        gift_card_text: '选择您的 20 美元电子礼品卡',
        btn_text: '领取我的奖励'
    },
    formBasic: {
        title: '注册您的保修<br><span style="color:#C9A127">领取神秘礼物</span>',
        form_email: '电子邮箱',
        form_email_note: '用于礼品发送和售后支持',
        form_order: '订单号',
        order_why: '*如何查找订单号？',
    },
    uploadPic: {
        guideText: '需要帮助截图吗？<br><small>请在下方选择购买平台，查看快速指南。</small>',
        title: '请上传一张展示您产品使用体验的截图。',
        text: '如需领取 20 美元礼品卡，请在下方提交<br>已发布评价的截图。',
        add_pic: '点击上传或拖拽文件到此处',
        add_pic_text: 'JPG / PNG，最大 10MB',
        btn_text: '提交并领取礼品',
        uploading: '正在上传，请稍候',
        upload_required: '请先上传评价截图再继续。',
        no_file_selected: '未选择文件'
    },
    paypalForm: {
        title: '您的 20 美元礼品卡应该发送到哪里？',
        text: '（请确保 PayPal 信息准确无误，以免延误。）',
        form_paypal: 'PayPal 账户',
        form_ensure_paypal: '确认 PayPal 账户',
        form_paypal_name: 'PayPal 账户姓名'
    },
    thanksAll: {
        doneTitle: '全部完成！🎉', doneDescription: '我们已收到您的截图！礼品卡申请正在处理中。',
        request: '礼品卡申请', processing: '处理中', deliveryPrefix: '预计送达：', deliveryTime: '1-2 个工作日', deliverySuffix: '通过电子邮件发送。',
        rewardTitle: '您的奖励', rewardDescription: '一张 20 美元电子礼品卡将发送至您的邮箱。',
        verifyStep: '我们将在 1-2 个工作日内审核您提交的截图。', approvedStep: '审核通过后，礼品卡将发送至您的邮箱。', spamStep: '请记得检查垃圾邮件/广告邮件文件夹。', supportText: '有疑问？请通过以下邮箱联系我们：'
    },
    chooseGiftFirst: '请先选择一张礼品卡：Apple 或 Starbucks。',
    PayPal: 'PayPal 转账',
    综合评价: '综合评价',
    // 选择语言
    popupTitle: '选择语言',
    // 发送
    send: '确认',
    // 发送邮件
    sendEmail: '发送邮件',
    // 改变语言
    changeLanSes: '语言切换成功',

    // 中文
    chinese: '中文',
    // 法语
    french: 'Francais',
    // 英语
    english: 'English',
    // 德语
    german: 'Deutsch',
    // 西班牙语
    spanish: 'Espaiol',
    // 意大利语
    italian: 'Italiano',

    // 系统标题
    title: '买家之声',
    // 系统解释
    details: '倾听买家心声，提供优质产品和服务，\n感谢您一路相伴！',
    // input
    input: '请输入',

    sys: {
        // 明信片code码
        sendCode: `你好，
    感谢您的参与。
    请输入明信片上印有的蓝色唯一代码。`,
        // 明信片code码文本框提示
        codePlaceholder: '请输入您的代码！（例如：1234）',
        // 验证中
        verifying: '正在验证...',
        // 邮件提示
        email: '请输入您的邮箱地址以接收礼物。',
        // 邮件文本输入提示
        emailPlaceholder: '请输入您的邮箱！',
        // 邮件验证失败提示
        emailVerification: '邮箱验证失败！',
        // 确认邮件提示
        comfirmEmail: '请确认您将接收礼物的邮箱地址。',
        // 产品 文本信息
        productInfo: `以下是您在我们商店购买的商品信息：`,
        // 产品 图片
        productInfoPic: '<strong>{param}</strong>',
        // 打星文本提示
        starMsg: `您对这款产品或我们的服务满意吗？
    请为下面的产品打星评分：`,
        // 选择渠道提示 
        lowChannelSelect: '',
        channelSelect: '感谢您的参与，请选择您希望收到礼物的形式。',
        // 文字评价提示
        textRateQuestion: '<strong>添加文字评价</strong><br/>您喜欢什么？您是如何使用这个产品的？',
        // 用户评价后 展出用户评价内容提示
        formImgDetails: '您的评价详情：',
        // 引导用户 跳转到亚马逊 进行订单评价提示
        jumpAmazon: '购物体验对其他顾客尤为重要，如果您愿意在亚马逊上与其他顾客分享，可以获得额外奖励。<br/>请前往亚马逊订单页面，评价产品并上传截图。',
        // paypal 礼品卡类型时 提示
        extraInfo: '请输入您的 PayPal 账户！',
        // 订单号 提示
        orderNo: '请输入您的订单号！',
        // 最后结束语
        finally: '感谢您！您的礼物将在 72 小时内通过 customerservice8@yeah.net 发送到您的邮箱，请注意查收。',

        // 暂时没用上的
        previewPic: '预览提交信息图片',
        lowText: '感谢您的参与，请选择直接领取礼品卡或跳转到邮箱页面。',
    },
    client: {
        saveCode: '您的唯一代码：<strong>{param}</strong>'
    },
    pic: {
        // 用户评价后 form详情 标题
        title: '表单详情',
        // 用户评价后 form详情的明信片码
        code: '您的唯一代码：',
        // 用户评价后 form详情的邮件
        email: '邮箱：',
        // 用户评价后 form详情的文本评价
        written: '我的评价',
        // 用户评价后 form详情的产品图片文本
        picLabel: '猫咪图片：',
    }
}
